import store2 from 'node-modules-store2';

export default store2;
window.retentionBank = store2;



// WEBPACK FOOTER //
// ./assets/es6/common/retention-bank.es6